import { Link } from "react-router-dom";
import { useLang } from "../i18n/LangContext";
import { BrandLockup } from "./Brand";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-obsidian text-white/80 mt-32"
    >
      <div className="absolute top-0 left-0 right-0 gold-rule" />
      <div className="container-x py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5 space-y-6">
          <BrandLockup inverted />
          <p className="font-serif italic text-2xl text-white/95 leading-snug max-w-md">
            {t.footer.tag}
          </p>
        </div>

        <div className="md:col-span-3 space-y-4">
          <p className="eyebrow-light">{t.footer.sitemap}</p>
          <ul className="space-y-2 font-mono text-[12px] uppercase tracking-[0.18em]">
            <li>
              <Link to="/" className="hover:text-champagne transition-colors">
                {t.nav.home}
              </Link>
            </li>
            <li>
              <Link
                to="/solutions"
                className="hover:text-champagne transition-colors"
              >
                {t.nav.capabilities}
              </Link>
            </li>
            <li>
              <Link
                to="/sectors"
                className="hover:text-champagne transition-colors"
              >
                {t.nav.sectors}
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="hover:text-champagne transition-colors"
              >
                {t.nav.about}
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-champagne transition-colors"
              >
                {t.nav.contact}
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4 space-y-4">
          <p className="eyebrow-light">{t.contact.directEyebrow}</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href="mailto:contact@nivneconsulting.com"
                className="hover:text-champagne transition-colors"
                data-testid="footer-email"
              >
                contact@nivneconsulting.com
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/nivne-consulting-group"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-champagne transition-colors"
                data-testid="footer-linkedin"
              >
                LinkedIn
              </a>
            </li>
            <li className="text-white/55">{t.common.locations}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex items-center justify-between gap-3">
          <p className="font-sans text-[12px] tracking-wide text-white/55">
            {t.footer.copy}
          </p>
        </div>
      </div>
    </footer>
  );
}
